module.exports = {
	name: 'KrPanoClient',
	provides: 'krPanoClient',
	main: 'krpano_client.js',
	dependencies: {
		/** @type Logger */
		logger: true
	},
	init: 'init'
};
